// import {createMuiTheme} from '@material-ui/core/styles'
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles'



const theme = createMuiTheme({
 palette: {
     primary: {
         main: '#29588F' //blue[700]
     },
     secondary: {
        main: '#EF1927' //blue[200]
    },
 }
})

export default theme;